import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ProductDetailService } from '../../../services/product-detail.service'

@Component({
  selector: 'app-filter-form',
  templateUrl: './filter-form.component.html',
  styleUrls: ['./filter-form.component.scss'],
})
export class FilterFormComponent {
  @Input() filters: any
  @Input() showEditMetricsBtn = false
  @Input() showBulkEditsBtn = false
  @Input() entity: string
  @Input() filterVisible = false
  @Input() isFilterInvisible = false
  @Input() areExportsInFilter = false
  @Input() areAllProductsChecked = false
  @Input() checkedProducts = []
  @Input() tags = []
  @Input() isInProducts = false
  @Input() isEditingMetrics = false
  @Input() isExportButtonShown = false
  @Input() metricsLoading = false
  @Output() filterVisibleChange: EventEmitter<boolean> = new EventEmitter()
  @Output() onSubmit: EventEmitter<any> = new EventEmitter()
  @Output() onExportResult: EventEmitter<any> = new EventEmitter()
  @Output() onClearClick: EventEmitter<any> = new EventEmitter()
  @Output() setCheckedProductsToFalse: EventEmitter<any> = new EventEmitter()
  @Output() editDepotMetrics: EventEmitter<any> = new EventEmitter()
  @Output() saveDepotMetrics: EventEmitter<any> = new EventEmitter()
  @Output() cancelEditingMetricsMode: EventEmitter<any> = new EventEmitter()

  constructor(public productDetailService: ProductDetailService) {}

  public triggerOnSubmit() {
    this.onSubmit.emit(true)
  }

  public triggerOnClear() {
    this.onClearClick.emit(true)
  }

  public triggerExportResult(result: any) {
    this.onExportResult.emit(result)
  }

  public triggerOnVisibilityChange() {
    this.filterVisible = !this.filterVisible
    this.filterVisibleChange.emit(this.filterVisible)
  }

  refreshProduct() {
    this.onSubmit.emit()
  }

  setCheckedProductsToFalseMethod() {
    this.setCheckedProductsToFalse.emit()
  }

  editMetrics() {
    this.metricsLoading = false
    this.editDepotMetrics.emit()
  }

  saveMetrics() {
    this.metricsLoading = true
    this.saveDepotMetrics.emit()
  }

  cancelEditingMetrics() {
    this.cancelEditingMetricsMode.emit()
  }
}
